import { Box, Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.scss'
import VoucherCards from './VoucherCards';

    import { translation_en } from "../../translations/translation_en";
import { translation_hi } from "../../translations/translation_hi";
const RewordsAndVouComponent = () => {
    const navigate = useNavigate();


// ✅ Helper translation function to support "path.to.key" syntax
function translate(obj: any, path: string) {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}

// ✅ Choose translation based on saved language
const lang = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
const translations = lang.startsWith("hi") ? translation_hi : translation_en;

// ✅ Define t() function that mimics react-i18next’s syntax
const t = (key: string) => translate(translations, key);

    return (
        <Box sx={{ padding: "32px 20px", background: "linear-gradient(141deg, #282829 -0.06%, #620B17 97.43%);" }}>
            <p className='title'>{t("rewards.title")} </p>
            <p className='sub_title'>{t("rewards.sub_title")}</p>
            <VoucherCards />
            <Button sx={{
                background: "#C8172F", width: "100%", borderRadius: "8px", color: "#FFF", fontSize: "14px", lineHeight: "20px", fontWeight: "500", textTransform: "none",
                ":hover": { color: "#fff" }
            }}
                onClick={() => navigate('#')}
            >
                {t("rewards.view_all_reward")}
            </Button>

        </Box>
    );
};

export default RewordsAndVouComponent;
